import { render } from "./afterSales.vue?vue&type=template&id=5a1f37a0&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=5a1f37a0&scoped=true&lang=css"
import "./afterSales.vue?vue&type=style&index=1&id=5a1f37a0&lang=css"
script.render = render
script.__scopeId = "data-v-5a1f37a0"

export default script